import React from 'react';
import { Box } from '@withjoy/joykit';
import { RectangleLayerData } from './Layer.types';
import { layerLayoutToCss } from '@apps/card/utils';

export const RectangleLayer = (props: { layer: RectangleLayerData }) => {
  const { layer } = props;

  return (
    <Box
      style={{
        ...layerLayoutToCss(layer.layout),
        backgroundColor: layer.fillData.fill ?? 'rgba(255, 255, 255, 0.5)',
      }}
    />
  );
};
